const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  userId:state => state.user.id,
  merchantId: state => state.user.merchantId,
  roles: state => state.user.roles,
  platId: state => state.user.platId,
  platName: state => state.user.platName,
  addRouters: state => state.permission.addRouters,
  routers: state => state.permission.routers
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js